<template>
   <div class="goodsTable " ref="table" v-if="reflashComp">
           <!-- <table v-if='this.type === 3'>
          <thead>
            <tr>
              <td></td>

              <td>行号</td>
              <td>商品名称</td>
              <td>规格</td>
              <td>产地</td>
              <td>生产企业</td>
              <td>批号</td>
              <td>可售库存</td>
              <td>单价（元）</td>
              <td>实际单价</td>
              <td>单剂购买数量</td>

              <td>操作</td>
            </tr>
          </thead>
          <tbody v-if='info.length'>
            <template
              v-for="(item,index) in tempInfo">
              <tr :key="index">
                 <td @click="handleDetail(index)">
                  <lk-icon type="ios-arrow-forward" :class="{'turn':item.showMore,'icon':true}" />
              </td>
                <td>{{index+1}}</td>
                <td>
                      {{item[0].name}}
                </td>
                <td>{{item[0].spec}}</td>
                <td>{{item[0].countryOfOrigin}}</td>
                <td>{{item[0].producer}}</td>
                <td>{{item[0].batch}}</td>
                <td>{{item[0].inventoryNum}}</td>
                <td>{{item[0].retailPrice}}</td>
                <td>
                  <numberInput v-if="canChange" :ref="'goods'+(index*2+2)"
                    @on-change='handleChange'
                    v-model="info[item[0].index].realPrice" size='small'
                    :maxlength='10'></numberInput>
                  <span v-else>{{item[0].realPrice}}</span>
                </td>
                <td>
                  <numberInput :ref="'goods'+(index*2+1)" type='price'

                    v-model="info[item[0].index].goodsCount" size='small' @on-change='handleChange'
                    :maxlength='10' @on-blur="$emit('handleSalePrescription',item[0].index,item)"
                   :min='0.01'   :max='item.inventoryNum' @maxChange='maxChange'></numberInput>
                </td>

                <td class="ivu-table-cell">
                  <lk-button size='small' @click="deleteItem(index,item)" type='text-primary'>删除
                  </lk-button>
                </td>
              </tr>
              <tr class="detail" :key="index+'1'"
                v-if="info[index].showMore">
                <td colspan="12">
                  <div>

                    <span class="detailItem">
                      <span>商品编码：</span>
                      <span>{{item[0].inventoryInfo.drugSerialCode}}</span>
                    </span>
                    <span class="detailItem">
                      <span>储存条件：</span>
                      <span>{{item[0].storageCondition}}</span>
                    </span>

                    <span class="detailItem">
                      <span>仓库：</span>
                      <span>{{item[0].warehouseNames}}</span>
                    </span>
                    <span class="detailItem">
                      <span>货位：</span>
                      <span>{{item[0].locationCodes}}</span>
                    </span>

                  </div>

                </td>
              </tr>
            </template>


          </tbody>
          <td colspan="12" v-else class="noGoods">
            <div>
              <div class="center">
                <img :src="noDataPic" alt="">
                <div>暂无数据</div>
              </div>
            </div>
          </td>
        </table>-->
        <table  class="commonTable" >
          <thead>
            <tr>
              <td>
                <div class="moreInfo">
                  <span>
                    通用名称
                  </span>
                </div>
              </td>
              <td>规格</td>
              <td>单位</td>
              <td>购买数量</td>
              <td>批号</td>
              <td>有效期</td>
              <td>生产厂家</td>
              <td>单价（元）</td>
              <td>实际单价</td>
              <td>库存数量</td>
              <td>销售数量</td>
              <td>追溯码</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody v-if='info.length'>
            <template
              v-for="(sameItem,key) in tempInfo">
              <tr :key="index+key" v-for="(item,index) in sameItem.items">
                <td :rowspan="sameItem.items.length" v-if="index===0">
                  <div class="hasImg">
                    <span>
                      {{item.name}}
                    </span>
                  </div>
                </td>
                <td :rowspan="sameItem.items.length" v-if="index===0">{{item.spec}}</td>
                <td :rowspan="sameItem.items.length" v-if="index===0">{{item.drugMiniPackageUnit}}</td>
                <td :rowspan="sameItem.items.length" v-if="index===0">{{item.sameGoodsTotalNum|defaultStr}}</td>
                <td>
                  <lk-select
                  size='small'
                  :ref="'select'+key"
                  @on-change='handleSelectBatch($event,item,key)'
                  v-model="info[item.index].inventoryInfo.saleKey"
                  >
                    <lk-option v-for="(batch,i) in goodsBatchList[key]" :key="i" :value='batch.inventoryInfo.saleKey' :label='batch.inventoryInfo.goodsBatchNumber' :disabled='isTmall?false:selectedSaleKey.includes(batch.inventoryInfo.saleKey)'>
                       <div style="width:450px">
                       <span style="margin-right:8px">{{'批号：'+batch.inventoryInfo.goodsBatchNumber}}</span>
                       <span v-show="batch.isAbleEditPrice===1" style="margin-right:8px">{{'批次：'+batch.goodsBatchSeq}}</span>
                       <span>{{'有效期：'+batch.expire}}</span>
                       <span style="float:right;color:#ccc">{{'库存：'+batch.inventoryNum}}</span>
                       </div>
                    </lk-option>
                  </lk-select>
                </td>
                <td>
                  <span >{{item.expire|defaultStr}}</span>
                </td>
                <td>{{item.producer|defaultStr}}</td>
                <td>{{item.retailPrice|defaultStr}}</td>
                <!-- <td>{{item.inventoryInfo}}</td> -->
                <td>
                  <span>{{item.realPrice}}</span>
                </td>
                <td>{{item.inventoryNum|defaultStr}}</td>
                <td :class="{'inputError':errArr.includes(key+'')}">
                  <numberInput
                    type='ifNeedCheckAllNumber'
                    :ifNeedCheckAllNumber='true'
                    :frontDecimal='7'
                    :precision ='2'
                    v-model="info[item.index].goodsCount"
                    size='small'
                    @on-change='handleChange'
                    :maxlength='10'
                    @on-blur="$emit('handleSalePrescription',index+size*(page-1),item)"
                    :min='0'
                    :max='item.inventoryNum'
                    @maxChange='maxChange'>
                  </numberInput>
                </td>
                <td>
                  <lk-input  v-model="info[item.index].traceCode" size='small'  :disabled="codeModal" @on-focus='handleCode(item.index)'>
                  </lk-input>
                </td>
                <td class="ivu-table-cell">
                  <lk-button size='small' :disabled="(item.isRequired&&sameItem.items.length===1)" @click="deleteItem(item.index,item)" type='text-primary' >删除
                  </lk-button>
                  <lk-button size='small' @click="addExtra(item)" type='text-primary'>新增批号
                  </lk-button>
                </td>
              </tr>
            </template>


          </tbody>
          <td colspan="12" v-else class="noGoods">
            <div>
              <div class="center">
                <img :src="noDataPic" alt="">
                <div>暂无数据</div>
              </div>
            </div>
          </td>
        </table>
         <lk-modal v-model="codeModal" title="产品溯源码" @on-ok='handleCodeModal'>
        <div style="display:flex">

        <label style="width:60px">追溯码：</label>
       <lk-input type='textarea' :rows='6'
        v-model="traceCode"
        placeholder="多个商品追溯码请以逗号区分
如：1234567890，82012304321，3123213214"
        ></lk-input> </div>

      </lk-modal>
      </div>
</template>
<script>
import noDataPic from '../../assets/cashier/noData.png';
import numberInput from './NumberInput.vue';
import utils from '../../libs/utils';
import sale from '../../services/sale';

export default {
  name: 'goodsTable',
  components: {
    numberInput,
  },
  props: {
    purchaseType: {},
    type: {},
    data: {
      type: Array,

    },
    canChange: {
      type: Boolean,

    },
    errArr: {
      type: Array,

    },
    epDetailPrice: {
      type: Object,
      default: () => {},
    },
    epInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isTmall() { // 10天猫，13京东
      return [10, 13].indexOf(this.epInfo.sourceType) >= 0;
    },
    tempInfo() { // 展示几条药品信息
      const res = {};
      this.info.map((item, index) => {
        res[item.goodsStoreId] || (res[item.goodsStoreId] = { items: [], showMore: false });
        item.index = index;

        res[item.goodsStoreId].items.push(item);
      });
      return res;
    },
    selectedSaleKey() {
      const res = [];
      this.info.forEach((item) => {
        item.inventoryInfo.saleKey && res.push(item.inventoryInfo.saleKey);
      });
      return res;
    },
  },
  model: {
    prop: 'data',
    event: 'change',
  },
  watch: {
    tempInfo: {
      handler(val) {
        for (const key in val) {
          // this.goodsBatchList[key] || (this.goodsBatchList[key] = []);
          // this.goodsBatchList[key].length || ;
          if (!this.goodsBatchList[key]) {
            this.goodsBatchList[key] = [];
            this.getGoodsList(key);
          }
        }
      },
      deep: true,
    },
    data: {
      handler() {
        this.info = this.data;
        this.info.map((item) => {
          this.tempKeyList[item.goodsStoreId] = { frozenList: [] };
        });
      },
      deep: true,
    },
  },
  data() {
    return {
      tempKeyList: {},
      keyList: [], //
      codeModal: false,
      tempIndex: null,
      traceCode: '',
      reflashComp: true, // 手动刷新批号选择框
      noDataPic,
      info: [],
      page: 1,
      size: 5,
      showMoreList: {},
      goodsBatchList: {},
    };
  },
  methods: {
    handelrInventoryFrozen() {
      let frozenList = [];
      for (const key in this.tempInfo) {
        !this.keyList.includes(key) && this.tempInfo[key].items.forEach((item) => {
          if (this.tempKeyList[key] && this.tempKeyList[key].frozenList.length) {
            frozenList = this.tempKeyList[key].frozenList.map(froItem => froItem.saleKey);
          }
          if (item.inventoryEpFrozenList !== null && item.inventoryEpFrozenList.length && JSON.stringify(this.goodsBatchList) !== '{}') {
            item.inventoryEpFrozenList.forEach((frozenItem, index) => {
              if (index) {
                this.addExtra(item);
              }
              if (!frozenList.includes(frozenItem.saleKey)) {
                this.tempKeyList[key].frozenList.push(frozenItem);
              }
            });
          }
        });
        this.keyList.push(key);
      }
      this.defaultBath();
    },
    defaultBath() {
      for (const key in this.tempInfo) {
        const list = this.tempKeyList[key].frozenList;
        this.tempInfo[key].items.forEach((item, index) => {
          if (list.length && JSON.stringify(this.goodsBatchList) !== '{}') {
            if (list[index]) { // 后端让这么改，因为处方详情少  inventoryEpFrozenList
              this.info[item.index].goodsCount = list[index].num;
              this.handleSelectBatch(list[index].saleKey, item);
            }
          }
        });
      }
    },
    handleCode(index) {
      this.tempIndex = index;
      this.traceCode = this.info[index].traceCode;
      this.codeModal = true;
    },
    handleCodeModal(isShow) {
      if (!isShow && this.info[this.tempIndex]) {
        // this.info[this.tempIndex].traceCode = this.traceCode;
        this.$set(this.info[this.tempIndex], 'traceCode', this.traceCode);
      }
    },
    reFlash() {
      this.reflashComp = false;
      this.$nextTick(() => {
        this.reflashComp = true;
      });
    },
    handleSelectBatch(selectedKey, item) {
      this.goodsBatchList[item.goodsStoreId].forEach((batch) => {
        if (selectedKey === batch.inventoryInfo.saleKey) {
          batch.realPrice = this.epDetailPrice[item.goodsStoreId].realPrice;
          batch.retailPrice = this.epDetailPrice[item.goodsStoreId].retailPrice;
          for (const key in batch) {
            if (this.isTmall) { // 如果是天猫，this.info里面的价格取epDetailVoList.epDetail.retailPrice|realPrice，因为this.info里面的对象是外部带过来的，不需二次赋值
              if (key !== 'retailPrice' && key !== 'realPrice') {
                key === 'goodsCount' || (this.info[item.index][key] = utils.deepClone(batch[key]));
              }
            } else {
              key === 'goodsCount' || (this.info[item.index][key] = utils.deepClone(batch[key]));
            }
          }
          if (this.info[item.index].goodsCount > this.info[item.index].inventoryNum) {
            this.info[item.index].goodsCount = this.info[item.index].inventoryNum * 1;
            this.$Message.error('销售数量大于所选批次库存数量');
          }
        }
      });
      this.$emit('change', this.info);
    },
    getGoodsList(goodsStoreId) {
      this.$store.commit('setDisableLoading', true);
      const func = this.isTmall ? sale.getListGoodsByIdEp : sale.getGoodsListById;
      const params = {
        goodsStoreId,
        purchaseType: this.purchaseType,
        epId: this.isTmall ? this.epInfo.id : null,
      };
      func(params).then((res) => {
        if (res.data.status === 200) {
          const result = [];
          res.data.data && res.data.data.forEach((item) => {
            item.types = [];
            item.name = item.inventoryInfo.approvedDrugNames;
            item.spec = item.inventoryInfo.specifications;
            item.batch = item.inventoryInfo.goodsBatchNumber;
            item.expire = utils.formatDate(item.inventoryInfo.goodsExpiryDate);
            item.producer = item.inventoryInfo.manufacturer;
            item.drugMiniPackageUnit = item.inventoryInfo.drugMiniPackageUnit;
            item.unpackMinPkgUnit = item.inventoryInfo.unpackMinPkgUnit;
            // item.goodsCount = 1;

            item.inventoryNum > 1 ? (item.goodsCount = 1) : (item.goodsCount = item.inventoryNum);
            item.realPrice = item.realPrice;
            item.countryOfOrigin = item.inventoryInfo.countryOfOrigin;
            item.goodsLot = item.inventoryInfo.goodsBatchNumber;
            item.expireDate = item.inventoryInfo.goodsExpiryDate;
            item.goodsStoreId = item.inventoryInfo.goodsStoreId;
            item.inventoryInfo.isEphedrineDrugs === 1 && item.types.push('Ephedrine');
            item.isThirdEquipment === 1 && item.types.push('ThirdEquipment');
            (item.inventoryInfo.goodsExpiryDate - new Date().getTime()) <= 2592000000 && item.types.push('Expire');
            item.bottomPrice = item.retailPrice > item.maxPriceWithTax ? item.maxPriceWithTax : item.retailPrice;
            if (item.isPatientRebuy) {
              this.$emit('handlerPatientRebuy', item.goodsStoreId, true);
            }
            result.push(item);
          });
          const dataLink = result.some(item => item.isDataLink === 1);
          this.$set(this.goodsBatchList, goodsStoreId, result || []);
          this.isTmall ? this.handelrInventoryFrozen() : '';
          this.reFlash();
          this.$emit('getDataLink', dataLink);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        // console.log(err);

        utils.handleError(err);
      });
    },
    initItem(item) {
      const res = utils.deepClone(item);
      delete res.expire;
      delete res.producer;
      delete res.inventoryInfo.saleKey;
      delete res.inventoryInfo.saleKey;
      delete res.inventoryNum;
      delete res.retailPrice;
      return res;
    },
    addExtra(item) {
      this.info.push(this.initItem(item));
      this.$emit('change', this.info);
    },
    focusFirst() {
      // console.log(this.$refs);
      if (this.$refs.goods2) {
        this.$refs.goods2[0].focus();
      } else {
        this.$refs.goods1[0].focus();
      }
    },
    // handlePage(page) {
    //   this.page = page;
    // },
    // handleSize(size) {
    //   this.size = size;
    // },
    maxChange() {
      this.$Message.error('不可超库存销售');
    },
    deleteItem(index, delItem) {
      this.info.splice(index, 1);
      this.$emit('change', this.info);
      // if (!this.info.slice((this.page - 1) * this.size).length) {
      //   this.page > 1 && this.page--;
      // }
      this.$emit('handleSalePrescription', index, delItem, true);
    },
    handleDetail(index) {
      this.$set(
        this.info[index],
        'showMore',
        !this.info[index].showMore,
      );
    },
    handleChange() {
      this.$emit('change', this.info);
    },
  },
  mounted() {
    this.info = this.data;
    this.$nextTick(() => {
      const table = this.$refs.table.querySelectorAll('input');
      // console.log(table);
      table.forEach((item) => {
        item.cardPart = 'goods';
      });
    });
  },
};
</script>
<style lang="less" scoped>
  .goodsTable {
    .moreInfo {
      display: flex;
      justify-content: space-between;
      align-items: center;

      // width: 17vw;
      .labelInfo {
        display: flex;
        align-items: center
      }
    }
    ul {
      list-style: none;
    }

    // th.imgHead{
    // width: 17vw;

    // }
    .hasImg {
      display: flex;
      align-items: center;
      min-width: 168px;

      img {
        margin-right: 2px;
      }

      span {
        margin-left: 2px
      }
    }

    .pageContainer {
      text-align: right;
      margin-top: 8px
    }
  }

  .noGoods {
    >div {
      height: 125px;
      display: flex;
      justify-content: space-around;
      padding-top: 28px // width: 100%;
    }

    .center {
      height: 70px;
      color: rgba(0, 0, 0, 0.75);

      img {
        height: 50px;
      }
    }
  }

  table.commonTable {
    tr {
      td:nth-child(1) {
        width: 46px;

      }

      td:nth-child(2) {
       width: 56px;

      }

      td:nth-child(4) {
        min-width: 130px;

      }

      td:nth-child(5) {
        min-width: 134px;

      }

      td:nth-child(6) {
        min-width: 114px;

      }

      td:nth-child(7) {
        min-width: 142px;

      }

      td:nth-child(8) {
        min-width: 82px;

      }

      td:nth-child(9) {
        min-width: 82px;

      }

      td:nth-child(10) {
        min-width: 90px;

      }

      td:nth-child(11) {
        min-width: 66px;

      }
    }
  }
  .goodsTable{//收银台商品列表
  // overflow: auto;
  overflow-x: auto;
  // border: 1px solid #eee;
  table{
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #eee;

    // tr{
      // height: 46px
    // }
    td{
      border: 1px solid #dedede;
      min-width: 85px;
      padding: 0 13px;

    }

    thead{
      background: #fafafa;
      font-weight: 500
      }
    }
    .detail{
      background: #F5F5F5;
      padding: 12px 24px;
      >td{
        padding-right: 0;
       >div{

         display: flex;
         flex-wrap: wrap
       }
      }
      .detailItem{
        margin-right: 30px
      }
    }
}
</style>
